import youtubeManager from '../module/libs/youtube';

let youtube = new youtubeManager();
export default class technologyManager {

    constructor() {

        //slider
        this.slider = document.getElementById('p-kv-slider');
        this.swipper = document.querySelector('.swiper-container');
        this.pagenation = document.getElementById('p-kv-fixed__pagination').querySelectorAll('li');
        this.mySwiper;
        this.number = 0;
        this.index = 0;
        this.slideIndex = 0;

        //movie
        this.outer = document.getElementById('p-triple_thermo-movie');
        this.image = document.getElementById('p-triple_thermo-movie-image');
        this.movie = document.getElementById('p-triple_thermo-movie-player');
        this.icon = this.outer.querySelector('.icon');

        this.ytFlg = false;

        TweenMax.set(this.movie,{opacity: 0});

    }

    init() {

        this.mySwiper = new Swiper (this.swipper, {
            loop: true,
            speed: 600,
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            autoplay: true,
            initialSlide:0,
            fade: {
                crossFade: true
            },
            navigation: {
                nextEl: this.slider.querySelector('.swiper-button-next'),
                prevEl: this.slider.querySelector('.swiper-button-prev'),
            },
        });

        let _number = 0;

        this.mySwiper.on('slideChangeTransitionEnd', () => {
            TweenMax.set(document.getElementById('p-kv-fixed__pagination').querySelector(".is-current"), {className:"-=is-current"});
            if(this.mySwiper.activeIndex === 5){
                _number = 0;
            }else if(this.mySwiper.activeIndex === 4 || this.mySwiper.activeIndex === 0){
                _number = 3;
            }else if(this.mySwiper.activeIndex === 3){
                _number = 2;
            }else if(this.mySwiper.activeIndex === 2){
                _number = 1;
            }else if(this.mySwiper.activeIndex === 1){
                _number = 0;
            }
            TweenMax.set(this.pagenation[_number], {className:"+=is-current"});
        });

        for(var i=0; this.pagenation.length>i; i++){
            let _index = i;
            let _slideIndex = i + 1;
            if(_slideIndex === 4) _slideIndex = 0;
            this.pagenation[i].onclick = () => {
                TweenMax.set(document.getElementById('p-kv-fixed__pagination').querySelector(".is-current"), {className:"-=is-current"});
                TweenMax.set(this.pagenation[_index], {className:"+=is-current"});
                this.mySwiper.slideTo( _slideIndex );
            }

        }

        youtube.init('p-triple_thermo-movie-player', 'u6-CdjwwMwo');
        this.movie = document.getElementById('p-triple_thermo-movie-player');

        this.outer.onclick = () => {
            TweenMax.to([this.image,this.icon],0.5,{
                opacity:0,
                display: 'none'
            });
            TweenMax.to(this.movie,0.5,{
                opacity: 1
            });
            youtube.play('p-triple_thermo-movie-player');
            this.ytFlg = true;
        };

    }


    render(mouse){

        if (youtube.yt['p-triple_thermo-movie-player'] === 0) {
            TweenMax.to([this.image,this.icon],0.5,{
                opacity:1,
                display: 'block'
            });
            TweenMax.to(this.movie,0.5,{
                opacity: 0
            });
            this.ytFlg = false
        }


    }
    resize(_w,_h,_display){

    }

    modal(type){

    }

}
